import Vue from "vue";
import VueRouter from "vue-router";
import {overWriteRoute, findRoutes} from '@/plugin/routes/RouterFunctions'
import {dashboardLink, siteLink} from "../main";

import {dashboardMenu, dashboardRoutes} from '@/plugin/routes/DashboardRoutes'
import {siteRoutes} from '@/plugin/routes/SiteRoutes'
import store from '@/store'
import NotFound from "../views/NotFound.vue";
import SiteTemplate from "../views/site/SiteTemplate";

Vue.use(VueRouter);

// import auth views
import RedirectLoading from "../components/RedirectLoading";
import {getBaseDomain} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {flatMenu} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Menu";
import {checkServiceIsExpire} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/SiteServiceManager";


const routes = [
    {
        path: '/',
        name: 'Home',
        component: RedirectLoading,
    },
    ...dashboardRoutes,
    {
        path: '/template',
        name: 'Template',
        component: SiteTemplate,
        children: [
            ...siteRoutes
        ]
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound
    },
]


const router = new VueRouter({
    routes,
    mode: "history",
});

const checkUserAccess = (to) => {
    let user = store.getters['User/getProfile'];
    let generalRoutes = ['Home','Dashboard','Profile','Address','UserOrders','LoansUser','UserChats','UserSubscription']
    if(generalRoutes.indexOf(to.name) > -1){
        return true
    }

    if (user.role == 1 && user.type == 0) {
        // شرط چک میکنه که داخل
        let userRouteAccess = user.meta?.find(item => item.name == 'user_access')

        if (userRouteAccess == undefined || userRouteAccess.value == null) {
            return true;
        }
        userRouteAccess = JSON.parse(userRouteAccess.value)

        userRouteAccess = userRouteAccess.map((item) => {
            if (item.type == 'page') {
                return item.route;
            }
        });

        if (userRouteAccess.indexOf('*') > -1) {
            return true;
        }
        return userRouteAccess.indexOf(to.name) > -1
    }
    return true
}


router.beforeEach((to, from, next) => {
    const routerName = to.name;
    const authRouters = [
        'Login', 'Register', 'ForgetPassword', 'EmailResetPassword', 'VerifiedEmail',
        'VerifiedCellphone', 'CellphoneResetPassword', 'Factor', 'verifyTransaction',
        'verifyTransactionWithoutAuthentication', 'Home', 'VerifyEmailRequest', 'SingleCourse', 'SingleChat', 'Product',
        'SinglePage', 'SinglePost', 'WishListUser', 'FactorWithSlug', 'UserWallets', 'Deliveries', 'HolooConfig', 'Offer'
    ];

    let storeRestriction = findAttributeOnSiteInfo('restrict_store_access_to_dashboard')[0];

    let checkRouteModule = flatMenu(dashboardMenu).find(item => {
        return item['route']['name'] == to.name
    });


    if (checkRouteModule != undefined && checkRouteModule['module'] != undefined) {
        if (!checkServiceIsExpire(checkRouteModule['module'])) {
            if (process.env.NODE_ENV == 'development') {
                next()
            } else {
                next('/dashboard/modules')
            }
        }
    }


    if (!checkUserAccess(to) && to.name != 'UserAccessDenied') {
        next("/user-access-denied")
    }

    if (store.getters['User/isUserStore'] && storeRestriction == 1) {
        window.location.href = siteLink
    }

    if (authRouters.indexOf(routerName) > -1) {

        let query = Object.keys(to.query)
            .map(key => {
                return (
                    encodeURIComponent(key) + '=' + encodeURIComponent(to.query[key])
                )
            })
            .join('&')

        window.location.href = siteLink + to.path + `?${query}`
    }
    next()
})

export default router;
